import { useState, useEffect } from "react";
import { useAsync } from "react-async";
import NotificationModel from "../../../api/models/notification";
import { getUserNotifications, getUserNotificationsByDisciplineId } from '../../../api/services/notificationService';
import { DashboardProps, DashboardPropsDefaults } from "../types/dashboardProps.d";
import Spinner from "../../spinner";

//If a discipline id has been selected, use that
const fetchUserNotifications = async (args: any) => await args[0] && args[0] > 0 ?
    getUserNotificationsByDisciplineId(args[0]) : getUserNotifications();

const DashboardWidgetHeaderNotification = ({ discipline, user }: DashboardProps): JSX.Element => {
    const [notifications, setNotifications] = useState<NotificationModel[]>([]);
    const [isFetching, setIsFetching] = useState<boolean>(false);

    //Get notifications
    const notificationsData = useAsync({
        deferFn: fetchUserNotifications,
        onResolve: (r) => {
            setIsFetching(false);
            setNotifications(r.data)
        },
    });

    //Refetch when the discipline changes
    useEffect(() => {
        setIsFetching(true);
        if (!isFetching) {
            notificationsData.run(discipline?.disciplineId)
        }
    }, [discipline]);

    return (
        <>
            {notifications.length > 0 ? <>
                <div className={`${DashboardPropsDefaults.containerClassNames} mr-0 widget-header-notification overflow-y-hidden`} style={{ height: '10rem' }}>
                    <Spinner show={notificationsData.isPending} />
                    {notifications.length > 0 && !notificationsData.isPending && <>
                        {notifications.map((notification: NotificationModel, i: number) =>
                            <div key={`dashboard-header-notification-${notification.notificationId}`} className={`${i === 0 ? `` : `border-t border-solid notification border-t-1 border-gray`}`}>
                                <div className="pb-0 dashboard-widget-title">
                                    <h3>{notification.title}</h3>
                                </div>

                                {/* Content */}
                                <div
                                    className={DashboardPropsDefaults.contentClassNames}
                                    dangerouslySetInnerHTML={{ __html: notification.text }}>
                                </div>
                            </div>
                        )}
                    </>}
                </div>
            </> : <></>}
        </>
    );
};

export default DashboardWidgetHeaderNotification;